export default __webpack_public_path__ + "static/media/08.e68a2b56.svg";